var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: _vm.formData.id ? "修改" : "新增",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            rules: _vm.rules,
            model: _vm.formData,
            "label-width": "120px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "获奖用户ID", prop: "student_id" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择",
                    disabled: _vm.formData.id != ""
                  },
                  model: {
                    value: _vm.formData.student_id,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "student_id", $$v)
                    },
                    expression: "formData.student_id"
                  }
                },
                _vm._l(_vm.studentList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.student_name + "-" + item.id_card,
                      value: item.student_id
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "最终分数", prop: "final_score" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入" },
                model: {
                  value: _vm.formData.final_score,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "final_score", $$v)
                  },
                  expression: "formData.final_score"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "最终时长(分钟)", prop: "final_duration" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "1:00.00" },
                model: {
                  value: _vm.formData.final_duration,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "final_duration", $$v)
                  },
                  expression: "formData.final_duration"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { label: "奖励层级描述", prop: "reward_name" }
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  clearable: "",
                  placeholder: "请输入"
                },
                model: {
                  value: _vm.formData.reward_name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "reward_name", $$v)
                  },
                  expression: "formData.reward_name"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }